import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';
function Reports(_ref) {
  let {
    color = colors.actionMinor[500],
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.906 8.445c0 1.046-.85 1.896-1.897 1.896-.06 0-.117-.012-.176-.018l-2.842 3.98c.109.238.173.5.173.78 0 1.046-.85 1.897-1.897 1.897a1.899 1.899 0 0 1-1.896-1.897c0-.143.019-.281.05-.415l-3.761-3.47a1.879 1.879 0 0 1-.557.092c-.366 0-.706-.11-.997-.29L4.88 13.253a1.895 1.895 0 0 1-1.89 1.83 1.899 1.899 0 0 1-1.896-1.896c0-1.047.85-1.897 1.897-1.897.366 0 .706.109.997.29l4.226-2.254a1.895 1.895 0 0 1 1.89-1.83c1.045 0 1.896.851 1.896 1.897 0 .143-.019.281-.05.415l3.761 3.47c.177-.054.362-.091.556-.091.061 0 .118.012.177.018l2.841-3.98a1.88 1.88 0 0 1-.172-.78c0-1.046.85-1.897 1.896-1.897 1.046 0 1.897.85 1.897 1.897Z",
    fill: color
  }));
}
export default Reports;